/* sts-rewards.js — /pages/rewards (v7 handoff 3.1), sections/sts-rewards.liquid.
 *
 * Two jobs the server cannot do:
 *  - the live points balance (v7 Section 9 step 7). The server paints the
 *    synced metafield figure (snippets/sts-points-balance.liquid); the SDK
 *    then renders the customer's live redeemable points into the hidden
 *    data-lion-points="approved" element (requires a signed-in customer), and
 *    this copies that number into the tile and section 3's line, worth it at
 *    the theme setting's point value ("2,250 points · worth $22.50"). It only
 *    repaints when the SDK disagrees, so the usual load changes nothing.
 *    States on the root's data-pts: ok | wait (signed in, no synced figure) |
 *    err (wait outlived WAIT_MS) | off (blocked) | guest;
 *  - "Pass $X and the line starts over" names the shopper's OWN last tier,
 *    which the Routine milestones box knows once it has resolved their list
 *    (assets/sts-ms-box.js sets data-sts-ms-cap).
 * And, for the staff simulator only (data-on="demo", while it drives the
 * page), the prototype's sample balances on the three tiles.
 * The tiles' jumps are assets/sts-jump.js (data-sts-jump).
 */
(function (w, d) {
  'use strict';
  var root = d.querySelector('[data-sts-rw]');
  if (!root) return;
  var STS = (w.STS = w.STS || {});
  var html = d.documentElement;
  var cents = Math.max(0, Number(root.getAttribute('data-points-value')) || 1);

  function money(n) {
    var M = STS.money;
    return M ? M.format(Number(n) || 0) : '$' + (Number(n) || 0).toFixed(2);
  }
  function set(sel, text) {
    var el = root.querySelector(sel);
    if (el && el.textContent !== text) el.textContent = text;
  }
  function demo() { return root.getAttribute('data-on') === 'demo' && html.getAttribute('data-sts-preview') === '1'; }
  function typed() { return /^(qnew|qcustomer|qstale)$/.test(html.getAttribute('data-sts-state') || ''); }

  var WAIT_MS = 15000;
  var lion = root.querySelector('[data-sts-rw-lion]');
  /* The figure on screen; -1 = none yet (so a live 0 still paints). */
  var shown = root.hasAttribute('data-pts-n') ? Number(root.getAttribute('data-pts-n')) : -1;
  function state(st) {
    root.setAttribute('data-pts', st);
    var els = root.querySelectorAll('[data-sts-rw-mine-for]');
    for (var i = 0; i < els.length; i++) els[i].hidden = els[i].getAttribute('data-sts-rw-mine-for') !== st;
  }
  function paintPts(n) {
    var word = n === 1 ? 'point' : 'points';
    var num = n.toLocaleString('en-US');
    var worth = money(n * cents / 100);
    set('[data-sts-rw-pts]', num);
    set('[data-sts-rw-pts-cap]', word + ' \u00b7 worth ' + worth);
    set('[data-sts-rw-mine-pts]', num + ' ' + word);
    set('[data-sts-rw-mine-worth]', worth);
    state('ok');
  }
  function points() {
    if (!lion || demo()) return;
    /* Until the SDK has written a number nothing changes. */
    var t = lion.textContent || '';
    if (!/\d/.test(t)) return;
    var n = Number(t.replace(/\D/g, ''));
    if (!(n >= 0) || n === shown) return;
    /* The SDK says 0 for a customer it has not recognised; a synced figure
       above 0 is the better answer then, and the metafield catches up in minutes. */
    if (n === 0 && shown > 0) return;
    shown = n;
    paintPts(n);
  }
  function giveUp() {
    if (root.getAttribute('data-pts') !== 'wait' || demo()) return;
    set('[data-sts-rw-pts-cap]', 'on the points page');
    state('err');
  }

  function cap() {
    var box = root.querySelector('[data-sts-msbox][data-sts-ms-cap]');
    var v = box && Number(box.getAttribute('data-sts-ms-cap'));
    if (v > 0) set('[data-sts-rw-cap]', money(v).replace(/\.00(?=\D*$)/, ''));
  }

  var sample = null;
  function paintDemo() {
    if (!demo() || !typed()) return;
    /* Gifts to claim: the milestones box's own count for the simulated row
       (assets/sts-ms-box.js), so the tile and the card agree. */
    var host = root.querySelector('[data-sts-msbox][data-sts-ms-unclaimed]');
    if (host) {
      var g = Number(host.getAttribute('data-sts-ms-unclaimed')) || 0;
      set('[data-sts-rw-ms]', String(g));
      set('[data-sts-rw-ms-cap]', g === 1 ? 'gift to claim' : 'gifts to claim');
    }
    /* T7: the simulator's Milestones scenario, for the accounts outside the program. */
    var pv = STS.preview, sc = pv && pv.active && pv.selection && pv.selection.ms;
    if (sc === 'holdout' || sc === 'excluded' || sc === 'blocked') {
      set('[data-sts-rw-ms]', sc === 'holdout' ? 'Soon' : '\u2014');
      set('[data-sts-rw-ms-cap]', sc === 'holdout' ? 'rolling out' : sc === 'blocked' ? 'under review' : 'not on this account');
    }
    /* No skin type earns nothing until the quiz (DECISIONS): the card's own line. */
    if (sc === 'notype') {
      set('[data-sts-rw-ms]', 'Locked');
      set('[data-sts-rw-ms-cap]', 'Take the quiz');
    }
    if (!sample) {
      sample = true;
      set('[data-sts-rw-cash]', money(24.5));
      set('[data-sts-rw-cash-cap]', 'cash back to spend');
      paintPts(2250);
    }
  }

  function all() { points(); cap(); paintDemo(); }

  if (lion && w.MutationObserver) new w.MutationObserver(points).observe(lion, { childList: true, characterData: true, subtree: true });
  var box = root.querySelector('[data-sts-msbox]');
  if (box && w.MutationObserver) new w.MutationObserver(function () { cap(); paintDemo(); }).observe(box, { attributes: true, attributeFilter: ['data-sts-ms-cap', 'data-sts-ms-unclaimed'] });
  d.addEventListener('sts:state', all);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', all);
  else all();
  if (root.getAttribute('data-pts') === 'wait') w.setTimeout(giveUp, WAIT_MS);
})(window, document);
